import React from "react";
import { matchPath, Route, Switch, useLocation } from "react-router-dom";

import { Box, Stack } from "@mui/material";
import { FileViewer } from "components/popups";
import {
  AllFiles,
  DealFolders,
  Deals,
  Folder,
  Folders,
  FullScreenRoutes,
  RecentlyAdded,
  Sidebar
} from "components/Workspace";
import { useWorkspace, WorkspaceProvider } from "components/Workspace/WorkspaceContext";
import { Routes } from "constants/routes";
import { IFile } from "store/types";

const WorkspaceFileViewer: React.FC = () => {
  const { previewFile, setPreviewFile } = useWorkspace();
  return <FileViewer file={previewFile as IFile} isOpen={Boolean(previewFile)} onClose={() => setPreviewFile(null)} />;
};

const fullScreenRoutes = [
  Routes.workspaceDealFolderDocument,
  Routes.workspaceDealFolderForm,
  Routes.workspaceFolderDocument,
  Routes.workspaceFolderForm
];

export const Workspace: React.FC = () => {
  const { pathname } = useLocation();
  const isFullScreenRoute = fullScreenRoutes.some((path) => matchPath(pathname, { path }));

  return (
    <Stack
      sx={{
        width: "100%",
        height: "100%",
        flex: 1,
        minHeight: 0,
        gap: "16px",
        overflow: "hidden"
      }}
    >
      <WorkspaceProvider>
        <FullScreenRoutes open={isFullScreenRoute} />
        <Stack
          sx={{
            flexDirection: "row",
            gap: "10px",
            flex: 1,
            minHeight: 0,
            position: "relative",
            overflow: "hidden"
          }}
        >
          <Sidebar />
          <Stack
            sx={{
              flex: 1,
              minHeight: 0,
              minWidth: 0,
              padding: "10px 16px",
              borderRadius: "8px",
              backgroundColor: "#fff",
              overflow: "hidden"
            }}
          >
            <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>
              <Switch>
                <Route path={Routes.workspaceDeals} component={Deals} />
                <Route path={Routes.workspaceFolders} component={Folders} exact />
                <Route path={Routes.workspaceDeal} component={DealFolders} exact />
                <Route path={Routes.workspaceDealFolder} component={Folder} exact />
                <Route path={Routes.workspaceAllFiles} component={AllFiles} exact />
                <Route path={Routes.workspaceRecentlyAdded} component={RecentlyAdded} exact />
                <Route path={Routes.workspaceFolder} component={Folder} exact />
              </Switch>
            </Box>
          </Stack>
        </Stack>
        <WorkspaceFileViewer />
      </WorkspaceProvider>
    </Stack>
  );
};
